import { DocumentInfo } from '../../models';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ResourceProvider } from '../resource/resource';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BescheideService {
  private readonly resourceProvider: ResourceProvider = inject(ResourceProvider);

  public getBescheide(): Observable<DocumentInfo[]> {
    return this.resourceProvider.getFinishedClaims();
  }

  public getSingleBescheid(rGuid: string): Observable<DocumentInfo | undefined> {
    return this.getBescheide().pipe(map((bescheide: DocumentInfo[]) => bescheide.find((x) => x.rGuid === rGuid)));
  }

  public getCountOfNewBescheide(): Observable<number> {
    return this.getBescheide().pipe(
      map((bescheide) => bescheide.filter((value) => !value.deliveredOn && value.tokenState !== 'NA').length),
    );
  }
}
